import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5001 4C14.4723 4 17.7223 6.58556 17.7223 9.77778C17.7223 12.97 14.4723 15.5556 10.5001 15.5556C9.6045 15.5556 8.74505 15.4256 7.95061 15.1944C5.84172 17 3.27783 17 3.27783 17C4.96061 15.3172 5.22783 14.1833 5.26394 13.75C4.03617 12.7172 3.27783 11.3161 3.27783 9.77778C3.27783 6.58556 6.52783 4 10.5001 4ZM9.77783 11.9444V13.3889H11.2223V11.9444H9.77783ZM9.77783 10.5H11.2223V6.16667H9.77783V10.5Z" fill="currentColor" />
  </svg>
);